module.exports = {"350122100":"凤城镇","350122101":"敖江镇","350122102":"东岱镇","350122103":"琯头镇","350122104":"晓澳镇","350122105":"东湖镇","350122106":"丹阳镇","350122107":"长龙镇","350122108":"透堡镇","350122109":"马鼻镇","350122110":"官坂镇","350122111":"筱埕镇","350122112":"黄岐镇","350122113":"苔菉镇","350122114":"浦口镇","350122115":"坑园镇","350122200":"潘渡乡","350122201":"江南乡","350122202":"蓼沿乡","350122203":"安凯乡","350122204":"下宫乡","350122205":"小沧畲族乡","350122400":"马祖乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350122.json
// module id = 1168
// module chunks = 0